import React, { useContext } from 'react';
import { Layout, Typography, Space, Grid, Row, Col } from 'antd';
import BoxedContainer from '../UI/BoxedContainer';
import { Link, useNavigate } from 'react-router-dom';
import { ConfiguratorContext } from '../../routes/Configurator/context';
import './Footer.css';

const { useBreakpoint } = Grid;

const Footer = () => {
    
    const screens = useBreakpoint();

    const navigate = useNavigate();
    const { resetState } = useContext(ConfiguratorContext);

    const handleChangeProductClick = (e: React.MouseEvent) => {
        e.preventDefault();
        resetState();
        navigate('/');
    };

    const [linkArrow, setLinkArrow] = React.useState('/build/images/circle-arrow-blue.svg');

    const handleMouseEnter = (e: React.MouseEvent<HTMLImageElement>) => {
        setLinkArrow('/build/images/circle-arrow-blue-hover.svg');
    };
    const handleMouseLeave = (e: React.MouseEvent<HTMLImageElement>) => {
        setLinkArrow('/build/images/circle-arrow-blue.svg');
    }

    return (
        <Layout.Footer className='footer'>
            <Row className='footer-links-row'>
                <Col span={24}>
                    <BoxedContainer>

                        <div className='text-right mb-4'>
                            <a href="/" onClick={handleChangeProductClick}>
                                <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                    Ändern Sie das zu konfigurierende Produkt
                                    <img className='icon rotate-180' src={linkArrow} alt="arrow left" />
                                </span>
                            </a>
                        </div>

                    </BoxedContainer>
                </Col>
            </Row>
            <Row className='footer-first-row'>
                <Col span={24}>
                    <BoxedContainer>
                        <div className={`footer-first-row-content ${!screens.md ? 'text-center' : 'text-right'}`}>
                            <ul>
                                <li>
                                    <Typography.Text className='text-uppercase'>
                                        <a href="https://www.eclisse.at/de-at/kontakt/" target='_blank' rel="noreferrer">
                                            Kontakt
                                        </a>
                                    </Typography.Text>
                                </li>
                                <li>
                                    <Typography.Text className='text-uppercase'>
                                        <a href="https://www.eclisse.at/de-at/firma/" target='_blank' rel="noreferrer">
                                            Unternehmen
                                        </a>
                                    </Typography.Text>
                                </li>
                                <li>
                                    <Typography.Text className='text-uppercase'>
                                        <a href="https://www.eclisse.at/de-at/land-auswahlen/" target='_blank' rel="noreferrer">
                                            <i className='icon-flag icon-flag-AT'></i>
                                            Österreich <span className='language'>(de-at)</span>
                                        </a>
                                    </Typography.Text>
                                </li>
                            </ul>
                        </div>
                    </BoxedContainer>
                </Col>
            </Row>
            <Row className='footer-second-row'>
                <Col span={24}>
                    <BoxedContainer>
                        <div className={`footer-second-row-content ${!screens.md ? 'text-center' : 'text-left'}`}>
                            <p>
                                COPYRIGHT ECLISSE S.R.L. 2020 -
                                ALL RIGHTS RESERVED - Steuernummer: UID: ATU 53625705  - TEL: <a href="tel:+43 1 9616565">+43 1 9616565</a>
                            </p>

                            <nav>
                                <Space direction={!screens.md ? 'vertical' : 'horizontal'}>

                                    <a href="https://www.eclisse.at/de-at/markenrichtlinien/" target='_blank' rel="nofollow noreferrer">Markenrichtlinien</a>
                                    <Link to="/datenschutz/" rel="nofollow">Datenschutz</Link>
                                    <Link to="/impressum" rel="nofollow">Impressum</Link>
                                    <a href="https://www.eclisse.at/de-at/agb/" target='_blank' rel="nofollow noreferrer">Agb</a>
                                    <a href="https://www.eclisse.at/de-at/blog/" target='_blank' rel="nofollow noreferrer">Blog</a>
                                </Space>
                            </nav>
                        </div>
                    </BoxedContainer>
                </Col>
            </Row>
        </Layout.Footer>
    )
}

export default Footer;